import { Link } from 'react-router'
import styled from 'styled-components'
import { breakPoints, breakPointsCss, colors } from '../utils/config'
import { Button, Icon } from '@bm-js/atlascloud-ui'
import {
  CourseBM,
  LucideIconName,
  parseDateTime,
} from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

const StyledCourseCard = styled.div`
  padding: 0.5rem;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  position: relative;
  align-items: center;
  &:after {
    position: absolute;
    content: '';
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 1px;
    background: ${colors.blackAlpla300};
  }
  .user-col {
    p {
      color: ${colors.gray700};
    }
  }
  ${breakPointsCss.tablet} {
    grid-template-columns: 1fr;
    .last-login {
      display: none;
    }
  }
`

type Props = {
  course: CourseBM
  deleteCourse: () => void
}

const CourseCard = ({ course, deleteCourse }: Props) => {
  const { tr } = useTr()
  const tablet = window.innerWidth < breakPoints.tablet

  return (
    <StyledCourseCard>
      <div className='user-col'>
        <p className='m0 b'>{course.name}</p>
        <p>
          {course.published
            ? tr(TrKey.coursePublished)
            : tr(TrKey.courseNotPublished)}
        </p>
      </div>
      <div>
        <p className='m0 b'>{tr(TrKey.courseLastUpdated)}</p>
        <p>{parseDateTime(course.updatedAt)}</p>
      </div>
      <div className='user-col jsfe gap1 flex'>
        <Link to={`/courses/${course._id}`}>
          <Button withIcon={tablet} className='text-white'>
            {tablet ? (
              <Icon name={LucideIconName.Pen} className='size-5' />
            ) : (
              tr(TrKey.edit)
            )}
          </Button>
        </Link>
        <Button
          danger
          onClick={deleteCourse}
          withIcon={tablet}
          className='text-white'
        >
          {tablet ? (
            <Icon name={LucideIconName.Trash2} className='size-5' />
          ) : (
            tr(TrKey.delete)
          )}
        </Button>
      </div>
    </StyledCourseCard>
  )
}

export default CourseCard
